<template>
  <v-container fluid>
    <v-layout row wrap>
      <!-- Carousel -->
      <v-flex xs8 class="pb-3">
        <carousel-3d
          class="mt-0 mb-0"
          ref="helpCarousel"
          display="1"
          :clickable="false"
          perspective="0"
          inverse-scaling="0"
          space="0"
          width="1280"
          height="720"
          border="0"
          @before-slide-change="slideChange($event)">
          <slide v-for="(slide, i) in slides" :index="i" :key="i">
            <div id="carousel-img" :style="{ backgroundImage: 'url(' + slide.src + ')'}" />
          </slide>
        </carousel-3d>
      </v-flex>
      <!-- Description -->
      <v-flex xs1 />
      <v-flex xs3 class="dayBorder">
        <v-card class="weekendBack elevation-0 pl-3">
          <!-- Slide Title -->
          <v-flex xs12 class="pb-3 pt-0 font-number">{{ slides[currentIdx].name }}</v-flex>
          <v-flex
            xs12
            class="pb-3"
            v-for="(item, i) in slides[currentIdx].elements"
            :key="i">
            <v-layout row wrap align-center>
              <!-- Icon -->
              <v-flex xs1>
                <v-avatar size="30px" :style="{ 'background-color' : elementColor(item.type)}">
                  <span class="white--text">{{ item.number }}</span>
                </v-avatar>
              </v-flex>
              <!-- Item -->
              <v-flex xs11>{{ item.text }}</v-flex>
            </v-layout>
          </v-flex>
        </v-card>
      </v-flex>
      <!-- Controls -->
      <v-flex xs8>
        <v-layout
          row
          wrap
          align-center
          class="text-xs-center font-number-2">
          <v-flex xs1 />
          <v-flex xs2>
            <v-icon class="icon-transform-1 arrowsStyle" @click="prevSlide()">keyboard_arrow_left</v-icon>
          </v-flex>
          <v-flex xs6>
            <v-layout>
              <v-flex
                xs3
                v-for="(slide, i) in slides"
                :index="i"
                :key="i"
                :style="slideSelect(i)">
                {{ i+1 }}
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs2>
            <v-icon class="icon-transform-1 arrowsStyle" @click="nextSlide()">keyboard_arrow_right</v-icon>
          </v-flex>
          <v-flex xs1 />
        </v-layout>
      </v-flex>
      <!-- FAQ -->
      <v-flex xs1 />
      <v-flex xs3 text-xs-center>
        <v-btn
          color="primary"
          @click="dialog = true"
          slot="activator"
          dark>
          How to play a video
        </v-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="font-heading">How to play a video</v-card-title>
        <v-card-text>
          1. On the home page, use the Selector
          <v-icon>keyboard_arrow_left</v-icon>
          <v-icon>view_carousel</v-icon>
          <v-icon>keyboard_arrow_right</v-icon> to choose the desire Brand / Type of videos.
          <br>
          <br> 2. Select the desired category indicated with the
          <v-icon>touch_app</v-icon> icon.
          <br>
          <br> 3. Browse with the arrows until the desire class comes on front.
          <br>
          <br> 4. Press the Play button
          <v-icon>play_arrow</v-icon>.
          <br>
          <br> 5. Use the Playback buttons if needed. Once loaded, the video will play automatically.
          <br>
          <br> 6. To exit the video use the
          <v-icon>arrow_back</v-icon> button.
          <br>
          <br> 7. When exiting the video, you will find the Voting
          <v-icon>thumb_up</v-icon>
          <v-icon>thumb_down</v-icon> page. This page can be skipped with the
          <v-icon>arrow_back</v-icon> button.
          <br>
          <br>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      tempIdx: 0,
      currentIdx: 0,
      dialog: false,
      slides: [
        {
          src: "/static/images/help/HELP_Home.png",
          name: "Home",
          elements: [
            {
              number: 1,
              type: "button",
              text: "Menu Button"
            },
            {
              number: 2,
              type: "button",
              text: "Selector Left Button"
            },
            {
              number: 3,
              type: "button",
              text: "Selector Right Button"
            },
            {
              number: 4,
              type: "button",
              text: "Next Class / Calendar Button"
            },
            {
              number: 5,
              type: "button",
              text: "Category Select Button"
            },
            {
              number: 6,
              type: "button",
              text: "Scroll Arrow Button"
            },
            {
              number: 7,
              type: "element",
              text: "Category Description"
            },
            {
              number: 8,
              type: "element",
              text: "Brand / Type Selector"
            },
            {
              number: 9,
              type: "element",
              text: "Clock"
            }
          ]
        },
        {
          src: "/static/images/help/HELP_Category.png",
          name: "Category",
          elements: [
            {
              number: 1,
              type: "button",
              text: "Menu Button"
            },
            {
              number: 2,
              type: "button",
              text: "Return Button"
            },
            {
              number: 3,
              type: "button",
              text: "Home Button"
            },
            {
              number: 4,
              type: "button",
              text: "Previous Class Button"
            },
            {
              number: 5,
              type: "button",
              text: "Start Class Button"
            },
            {
              number: 6,
              type: "button",
              text: "Next Class Button"
            },
            {
              number: 7,
              type: "element",
              text: "Category Description"
            },
            {
              number: 8,
              type: "element",
              text: "Clock"
            }
          ]
        },
        {
          src: "/static/images/help/HELP_Player.png",
          name: "Player",
          elements: [
            {
              number: 1,
              type: "button",
              text: "Exit Video Button"
            },
            {
              number: 2,
              type: "button",
              text: "Play / Pause Button"
            },
            {
              number: 3,
              type: "button",
              text: "Volume / Mute Button"
            },
            {
              number: 4,
              type: "button",
              text: "Seek Volume Button"
            },
            {
              number: 5,
              type: "button",
              text: "Seek Time Button"
            },
            {
              number: 6,
              type: "button",
              text: "Close Caption Button"
            },
            {
              number: 7,
              type: "button",
              text: "Lights Button"
            },
            {
              number: 8,
              type: "element",
              text: "Total Time"
            },
            {
              number: 9,
              type: "element",
              text: "Elapsed Time"
            },
            {
              number: 10,
              type: "element",
              text: "Class Name"
            },
            {
              number: 11,
              type: "element",
              text: "Clock"
            }
          ]
        },
        {
          src: "/static/images/help/HELP_Voting.png",
          name: "Voting",
          elements: [
            {
              number: 1,
              type: "button",
              text: "Exit Voting Button"
            },
            {
              number: 2,
              type: "button",
              text: "Like Button"
            },
            {
              number: 3,
              type: "button",
              text: "Dislike Button"
            },
            {
              number: 4,
              type: "element",
              text: "Remaining Time"
            }
          ]
        },
        {
          src: "/static/images/help/HELP_Calendar.png",
          name: "Calendar",
          elements: [
            {
              number: 1,
              type: "button",
              text: "Menu Button"
            },
            {
              number: 2,
              type: "button",
              text: "Home Button"
            },
            {
              number: 3,
              type: "element",
              text: "Classes on this Day"
            },
            {
              number: 4,
              type: "element",
              text: "Current Month & Week"
            },
            {
              number: 5,
              type: "element",
              text: "Clock"
            }
          ]
        }
      ]
    };
  },
  methods: {
    slideChange(index) {
      this.currentIdx = index;
    },
    prevSlide() {
      if (this.tempIdx > 0) {
        this.tempIdx -= 1;
        this.$refs.helpCarousel.goSlide(this.tempIdx);
      } else {
        this.tempIdx = this.slides.length - 1;
        this.$refs.helpCarousel.goSlide(this.tempIdx);
      }
    },
    nextSlide() {
      if (this.tempIdx < this.slides.length - 1) {
        this.tempIdx += 1;
        this.$refs.helpCarousel.goSlide(this.tempIdx);
      } else {
        this.tempIdx = 0;
        this.$refs.helpCarousel.goSlide(this.tempIdx);
      }
    },
    slideSelect(i) {
      if (i === this.tempIdx) {
        return "color: white; transform: scale(1.5);";
      } 
      return "color: grey";
      
    },
    elementColor(e) {
      if (e === "button") {
        return "#f50057";
      } 
      return "#2962ff";
      
    }
  }
};
</script>

<style scoped>
.weekendBack {
  min-height: 100%;
  background: linear-gradient(#303030, #252525 20%, #252525 80%, #303030);
}

.dayBorder {
  border-right: 2px solid;
  border-left: 2px solid;
  border-image: linear-gradient(
    to top,
    #303030,
    #707070 30%,
    #707070 70%,
    #303030
  );
  border-image-slice: 1;
}
.arrowsStyle {
  font-size: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Help.vue